import { useEffect, useState } from "react";
import {
  calculateRiskScore,
  getColorProbability,
  getColorScore,
  getImageURLScore,
} from "../../../utils/utils";
import { HiOutlineTrendingUp, HiOutlineCurrencyDollar } from "react-icons/hi";

export const EvaluationScore = ({
  data,
  score,
  probability,
  decisao = null,
  showSuggestion = true,
}) => {
  const [riskScore, setRiskScore] = useState(0);

  useEffect(() => {
    setRiskScore(
      calculateRiskScore(
        +data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal || 0,
        +data?.resumoConsulta?.protestos?.quantidadeTotal || 0,
        +score,
        +probability
      )
    );
  }, [data, score, probability]);

  return (
    <div className="space-y-6">
      {/* Renda Presumida */}
      <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <HiOutlineCurrencyDollar className="text-primary text-3xl" />
          <h2 className="text-lg font-semibold text-gray-700">
            Renda Presumida
          </h2>
        </div>
        <div className="text-2xl font-bold text-primary mb-2">
          {data?.dadosCadastrais?.rendaPresumida || "Sem informação"}
        </div>
        <div className="text-sm text-gray-500">
          {data?.dadosCadastrais?.textoRendaPresumida ||
            "Sem informação detalhada"}
        </div>
      </div>

      {/* Score e Probabilidade lado a lado */}
      <div className="grid grid-cols-2 gap-6">
        {/* Score */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <HiOutlineTrendingUp className="text-yellow-400 text-3xl" />
            <h2 className="text-lg font-semibold text-gray-700">
              Score de Risco
            </h2>
          </div>

          <div className="flex justify-center mb-4">
            <img src={getImageURLScore(score)} alt="Score" className="h-32" />
          </div>

          <div
            className="mx-auto text-white font-semibold text-lg rounded-full px-6 py-2 w-36 text-center"
            style={{ backgroundColor: getColorScore(score) }}
          >
            Score {score}
          </div>
        </div>

        {/* Probabilidade (sem chart) */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            Probabilidade de Inadimplência
          </h2>

          <div className="text-3xl font-bold text-gray-800 mb-4">
            {probability / 100}%
          </div>

          <div className="w-full bg-gray-200 rounded-full h-6 overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{
                width: `${probability / 100}%`,
                backgroundColor: getColorProbability(probability / 100),
                transition: "width 0.5s ease",
              }}
            ></div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded shadow-sm text-sm text-gray-700 mt-4">
            <strong>Aviso:</strong> A decisão de concessão de crédito é de
            responsabilidade exclusiva do concedente. As informações fornecidas
            são meramente auxiliares e não constituem recomendação.
          </div>
        </div>
      </div>

      {/* Aviso */}
    </div>
  );
};
